import Entity from './entity'
export default class MediaItem extends Entity<number>{
    ResponsibleUserId:number;
    description:string;
    shortDescription:string;
    filePath:string;
    fileWebPath:string;
    fileName:string;
    galleryId:number;
    customName:string;

    constructor() {
        super();
        this.fileWebPath= "";
  	}
}